import React from "react";
import PropertyCard from "./PropertyCard";
import "./FeaturedProperties.css";
import rusticproperties1 from "../img/rusticproperties/rusticproperties1.png";
import rusticproperties2 from "../img/rusticproperties/rusticproperties2.png";
import rusticproperties3 from "../img/rusticproperties/rusticproperties3.png";
import rusticproperties4 from "../img/rusticproperties/rusticproperties4.png";

function FeaturedProperties() {
  return (
    <div className="FeaturedProperties">
      <div className="FeaturedProperties__title">
        <h1>New Rustic retreat</h1>
      </div>
      <div className="FeaturedProperties__subtitle">
        <p></p>
      </div>
      <div className="FeaturedProperties__cards">
        <PropertyCard
         img="https://i.postimg.cc/436B0vxw/Frame-63-3.png"
         name="Luxury Rustic Villa"
         location="Benissa - SPAIN"
         price="1,695,000€"
         bedrooms="4"
         bathrooms="4"
         housesize="460 m²"
          status=""
         badgecolor=""
         slug="LUXUS_RUSTIC_VILLA_BENISSA_COSTA_BLANCA_SPANIEN_CFP-P1020"
        />
        <PropertyCard
          img="https://i.postimg.cc/3wQK0rXy/Frame-63-3.png"
          name="Project in Cumbre Del Sol Near Lady Elizabeth School"
          location="Benitachell - SPAIN"
          price="900,000€"
          bedrooms="4"
          bathrooms="4"
          housesize="280 m²"
        status=""
         badgecolor=""
          slug="PROJECT_IN_CUMBRE_DEL_SOL_NEAR_LADY_ELIZABETH_SCHOOL_CFP-P1003"
        />
        <PropertyCard
         img="https://i.postimg.cc/y8dVc2hd/g-e2-jpg-1.png"
         name="Luxury Villa Project"
         location="Costa Blanca - SPAIN"
         price="2,275,000€"
         bedrooms="3"
         bathrooms="5"
         housesize="425 sqm"
        status=""
         badgecolor=""
         slug="Luxury_Project_Panoramic_view_P1002"
        />
        <PropertyCard
         img="https://i.postimg.cc/rwJNwYjJ/Frame-63-1.png"
         name="Rustic Project"
         location="Costa Blanca - SPAIN"
         price="1,650,000€"
         bedrooms="3"
         bathrooms="3"
         housesize="305 m2"
         status=""
         badgecolor=""
         slug="RUSTIC_PROJECT_PANORAMIC_VIEWS_P1001"
        />
      </div>
      <div className="FeaturedProperties__viewmore">
        <a href="/RusticProperties">
          <p>View more</p>
        </a>
      </div>
    </div>
  );
}

export default FeaturedProperties;
